import { Music4 } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-100 py-16">
      <div className="max-w-7xl mx-auto px-6 text-center md:text-left">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
          
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 gold-gradient rounded-full flex items-center justify-center text-white">
              <Music4 size={16} />
            </div>
            <span className="text-lg font-bold">Encant.Me</span>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm font-medium text-slate-500">
            <a href="#" className="hover:text-slate-800 transition-colors">
              Termos
            </a>
            <a href="#" className="hover:text-slate-800 transition-colors">
              Privacidade
            </a>
            <a href="#" className="hover:text-slate-800 transition-colors">
              Contato
            </a>
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-slate-800 transition-colors"
            >
              Instagram
            </a>
          </div>
        </div>

        <p className="text-slate-400 text-sm text-center">
          © {currentYear} Encant-Me. Transformando relatos em arte sonora.
        </p>
      </div>
    </footer>
  );
};